if (window.innerWidth <= 740) {
    document.querySelector('.metaPanel-fitting-advice.desktop').remove();
}

const sizeConverterButton = document.querySelector('.size-converter-button');
const bodyMeasurementsButton = document.querySelector(
    '.body-measurements-button'
);
const tableSizeConverter = document.querySelector('.tables-size-converter');
const tableBodyMeasurements = document.querySelector(
    '.tables-body-measurements'
);

const bodyMeasurementsCMButton = document.querySelector(
    '.tables-body-measurements .measure-cm'
);
const bodyMeasurementsInchesButton = document.querySelector(
    '.tables-body-measurements .measure-inches'
);

if (sizeConverterButton) {
    sizeConverterButton.addEventListener('click', function () {
        bodyMeasurementsButton.classList.remove('current');
        this.classList.add('current');
        tableSizeConverter.classList.add('show');
        tableBodyMeasurements.classList.remove('show');
    });
}

if (bodyMeasurementsButton) {
    bodyMeasurementsButton.addEventListener('click', function () {
        sizeConverterButton.classList.remove('current');
        this.classList.add('current');
        tableSizeConverter.classList.remove('show');
        tableBodyMeasurements.classList.add('show');
    });
}

if (bodyMeasurementsCMButton) {
    bodyMeasurementsCMButton.addEventListener('click', function () {
        bodyMeasurementsInchesButton.classList.remove('current');
        this.classList.add('current');

        document
            .querySelectorAll('.body-measurement-table')
            .forEach((table) => {
                table.classList.remove('current');
            });

        document
            .querySelectorAll('.body-measurement-table.cm')
            .forEach((table) => {
                table.classList.add('current');
            });
    });
}

if (bodyMeasurementsInchesButton) {
    bodyMeasurementsInchesButton.addEventListener('click', function () {
        bodyMeasurementsCMButton.classList.remove('current');
        this.classList.add('current');

        document
            .querySelectorAll('.body-measurement-table')
            .forEach((table) => {
                table.classList.remove('current');
            });

        document
            .querySelectorAll('.body-measurement-table.inch')
            .forEach((table) => {
                table.classList.add('current');
            });
    });
}
